import React, { useMemo } from "react";

import Sidebar from "../Sidebar";
import Header from "../Header";
import TeacherDashboard from "./TeacherDashboard";
import NewMessagePopup from "./NewMessagePopup";
import { useAuth } from "../../context/AuthContext";
import { filterLinksByPermissions } from "../../config/permissions";
import { isReadOnlyTeacherDemo } from "../../utils/demoAccess";

const allTeacherLinks = [
  { to: "/teacher/home", label: "Home", feature: "home" },
  {
    to: "/teacher/grading",
    label: "Grading",
    feature: "grading",
    children: [
      { to: "/teacher/classes", label: "Classes", feature: "classes" },
      { to: "/teacher/student-profiles", label: "Student Profiles", feature: "studentProfiles" },
      { to: "/teacher/standards-progression", label: "Data Entry", feature: "dataEntry" },
      { to: "/teacher/assignments", label: "Learning Tasks", feature: "assignments" },
      { to: "/teacher/data-points-report", label: "View Data", feature: "viewData" },
      { to: "/teacher/reports", label: "Reports", feature: "reports" },
      { to: "/teacher/notes", label: "Teacher Notes", feature: "notes" },
    ],
  },
  {
    to: "/teacher/action",
    label: "Action",
    feature: "action",
    children: [
      { to: "/teacher/guided-actions", label: "Guided Actions", feature: "goals" },
      { to: "/teacher/action-cards", label: "Family Action Cards", feature: "actionCards" },
    ],
  },
  {
    to: "/teacher/connect",
    label: "Connect",
    feature: "connect",
    children: [
      { to: "/teacher/messaging", label: "Messaging", feature: "messaging" },
      { to: "/teacher/communication", label: "Communication Hub", feature: "communication" },
      { to: "/teacher/calendar", label: "Calendar", feature: "calendar" },
    ],
  },
  {
    to: "/teacher/help-support",
    label: "Help",
    feature: "helpSupport",
    children: [
      { to: "/teacher/help-support", label: "Help & Support", feature: "helpSupport" },
      { to: "/teacher/training-resources", label: "Training & Resources", feature: "professionalDevelopment" },
      { to: "/teacher/surveys", label: "Surveys", feature: "helpSupport" },
    ],
  },
];

const TeacherLayout = () => {
  const { user } = useAuth();
  const userRoles = useMemo(() => user?.roles || user?.role || [], [user?.roles, user?.role]);
  
  const teacherLinks = useMemo(
    () => isReadOnlyTeacherDemo(user)
      ? [
        { to: "/teacher/home", label: "Home" },
        { to: "/teacher/student-profiles", label: "Student Profiles" },
        { to: "/teacher/standards-progression", label: "Data Entry" },
      ]
      : filterLinksByPermissions(allTeacherLinks, userRoles),
    [userRoles, user]
  );

  return (
    <div className="ae-shell">
      <Sidebar links={teacherLinks} />
      <div className="ae-shell-content">
        <Header />
        <main className="ae-shell-main">
          <TeacherDashboard />
        </main>
      </div>
      <NewMessagePopup />
    </div>
  );
};

export default TeacherLayout;
